/*
Plastics

--fireRated <boolean::checkbox>
--manufacturer <Manufacturer>
--manufacturerNumber <string>
--computerEaseNumber <string>
*/
import { manufacturer } from '@/modules/standardItems/schemas/baseFilters'
import {
  fireRated,
  sheetStockFilters
} from '@/modules/standardItems/schemas/sheetStock/filters'

export default [
  {
    label: 'Name',
    value: 'name',
    type: 'list',
    returnObject: false
  },
  fireRated(),
  manufacturer(),
  ...sheetStockFilters()
]
